// src/utils/request.js
import axios from 'axios'
import {
	Message
} from 'element-ui'
import {
	baseURL
} from '@/utils/url'

// 创建 axios 实例
const service = axios.create({
	baseURL: baseURL + '/student/pc',
	timeout: 10000,
	headers: {
		'Content-Type': 'application/json;charset=utf-8'
	}
})

// 请求拦截器：请求发送前的处理
service.interceptors.request.use(
	config => {
		// 添加 token 到请求头（从本地存储获取）
		const token = localStorage.getItem('token')
		if (token) {
			config.headers.Authorization = `Bearer ${token}`
		}
		if (['post', 'put'].includes(config.method) && config.data) {
			// 如果参数是普通对象，转为 JSON 字符串（axios 会自动转，但手动兜底）
			if (typeof config.data === 'object' && !(config.data instanceof FormData)) {
				config.data = JSON.stringify(config.data)
			}
		}
		return config
	},
	error => {
		// 请求错误处理
		// console.error('请求拦截错误：', error)
		return Promise.reject(error)
	}
)

// 响应拦截器：响应返回后的处理
service.interceptors.response.use(
	response => {
		// 只返回响应的 data 部分，简化组件中使用
		const res = response.data
		// 需要登录
		if (res.errno == -1) {
			// console.error('res.errno == -1', res)
			localStorage.setItem('token', '')
		} else if (res.errno !== 0) {
			// 提示错误信息
			Message.error(res.errmsg || '请求失败')
			// 抛出错误，让组件的 catch 捕获
			return Promise.reject(res.errmsg || 'Error')
		} else {
			return res
		}
	},
	error => {
		// 统一处理网络错误/后端错误
		// console.error('响应错误：', error)
		// 不同错误类型的提示
		if (error.message.includes('timeout')) {
			Message.error('请求超时，请稍后重试')
		} else if (error.response) {
			// 有响应但状态码错误
			const status = error.response.status
			switch (status) {
				case 401:
					Message.error('登录失效，请重新登录')
					// 示例：跳转到登录页
					window.location.href = '/login'
					break
				case 403:
					Message.error('没有权限访问该资源')
					break
				case 404:
					Message.error('请求地址不存在')
					break
				case 500:
					Message.error('服务器内部错误')
					break
				default:
					Message.error(`请求失败：${error.response.data.errmsg || '未知错误'}`)
			}
		} else {
			// Message.error('网络异常，请检查网络连接')
		}
		return Promise.reject(error)
	}
)

// import request from '@/utils/request'
// Vue.prototype.$request = request


// // 封装 GET 方法
// service.get = function(url, params = {}) {
// 	return this({
// 		url,
// 		method: 'GET',
// 		params
// 	})
// }

// // 封装 POST 方法
// service.post = function(url, data = {}) {
// 	return this({
// 		url,
// 		method: 'POST',
// 		data
// 	})
// }

// // 封装 PUT/DELETE 方法
// service.put = function(url, data = {}) {
// 	return this({
// 		url,
// 		method: 'PUT',
// 		data
// 	})
// }

// service.delete = function(url, params = {}) {
// 	return this({
// 		url,
// 		method: 'DELETE',
// 		params
// 	})
// }
// 
export default service